import React, { useContext, useEffect, useState } from 'react';
import { notification } from 'antd';
import Colors from '../../../../constants/Colors.js';
import { AppContext } from 'App.context';
import { ApiContext } from 'utils/networking/Api.context';
import hbxConstants from '../hbxConstants.js';

export default function useHcnHook() {
  const { API } = useContext(ApiContext);

  const {
    appState,
    appActions: { translate, getSelectedHotel },
  } = useContext(AppContext);

  const [state, setState] = useState({
    isLoading: false,
    isActive: false,
    dataSource: {
      items: [],
      totalItems: 0,
      totalPages: 0,
      currentPage: 0,
      pageSize: 10,
    },
    IHClientID: null,
    AdviceDisableProduct: false,
    clientChannelID: null,
    suscription: null /* null | active | requested */,
    pmsNotPermit: null,
  });

  useEffect(() => {
    actions.getHbxSuscriptionStatus();
    actions.loadProduct();
  }, [state.dataSource.currentPage, state.filters, appState.selectedHotel]);

  const actions = {
    getHbxSuscriptionStatus: () => {
      updateState({ isLoading: true });

      API.getHbxSuscriptionStatus({
        hotelId: getSelectedHotel()?.key,
        nameProduct: 'hbx_hcn',
      }).then(res => {
        updateState({ suscription: res });
      });

      API.pmsHotelsRequest()
        .then(res => {
          const hotel = res?.find(h => h?.id === getSelectedHotel()?.id);
          if (!hbxConstants.HCN_PMS_PERMIT.includes(hotel?.pmsCheckin)) {
            updateState({ pmsNotPermit: hotel?.pmsCheckin });
          }
        })
        .catch(err => {
          console.warn(err);
        });

      API.salesChannelsRequest(
        state.dataSource?.currentPage,
        state.dataSource?.pageSize,
        {},
        null,
        getSelectedHotel()
      ).then(data => {
        let client = null;
        data?.items?.map(item => {
          if (item?.clients?.find(client => client?.client_id === 23)) {
            client = item.clients.find(client => client.client_id === 23);
          }
        });
        if (client?.id) {
          updateState({ IHClientID: client.id, isActive: !!client.enabled });
        }
      });
    },

    loadProduct: () => {
      const data = { items: [{ hotel: getSelectedHotel()?.name, client: 'HCN' }] };
      updateState({ dataSource: data, isLoading: false });
    },

    getStateTextColor: () => {
      if (state.isActive) {
        return Colors.greenHotelIntegratedText;
      } else {
        return Colors.redDesactivedText;
      }
    },

    getStateBackgroundColor: () => {
      if (state.isActive) {
        return Colors.greenHotelIntegratedBg;
      } else {
        return Colors.redDesactivedBg;
      }
    },

    getStateString: () => {
      if (state.isActive) {
        return translate('states.enabled');
      } else {
        return translate('states.disabled');
      }
    },

    changeOTAState: async value => {
      updateState({ isLoading: true });
      const hotelData = await API.getOneHotel({ hotelId: getSelectedHotel()?.key });

      if (value) {
        API.sendOptIn(
          getSelectedHotel()?.key,
          hotelData.atlasId,
          hbxConstants.HCN_PRODUCT,
          23,
          state.IHClientID
        )
          .then(res => {
            updateState({ isActive: value, IHClientID: res.newIHClientHotelId });

            let message = translate('hbxProducts.enableProduct');
            message = message.replace('%s', 'HCN');
            notification.success({
              message: message,
            });
          })
          .catch(err => {
            console.warn(err);
            notification.error({
              message: translate('hbxProducts.errorMessage'),
            });
          });
      } else {
        API.sendOptOut(
          getSelectedHotel()?.key,
          hotelData.atlasId,
          hbxConstants.HCN_PRODUCT,
          state.IHClientID
        )
          .then(() => {
            updateState({ isActive: value });
            let message = translate('hbxProducts.disableProduct');
            message = message.replace('%s', 'HCN');
            notification.success({
              message: message,
            });
          })
          .catch(err => {
            console.warn(err);
            notification.error({
              message: translate('hbxProducts.errorMessage'),
            });
          });
      }
      updateState({ isLoading: false });
    },

    setAdviceDisableProduct: show => {
      updateState({ AdviceDisableProduct: show });
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
}
